import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { logAppEnvironment } from './lib/appEnv'
import { AppErrorBoundary } from './components/AppErrorBoundary'

logAppEnvironment()

const rootElement = document.getElementById("root")!

document.documentElement.setAttribute("translate", "no")
document.documentElement.classList.add("notranslate")
document.body.setAttribute("translate", "no")
document.body.classList.add("notranslate")
rootElement.setAttribute("translate", "no")
rootElement.classList.add("notranslate")

createRoot(rootElement).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
)
